import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { toastApiRef, type ToastApi } from '@backstage/frontend-plugin-api';

const toastApiFactory = createApiFactory({
  api: toastApiRef,
  deps: { alertApi: alertApiRef },
  factory: ({ alertApi }): ToastApi => ({
    post(toast) {
      const title =
        typeof toast.title === 'string' ? toast.title : 'Notification';
      const description =
        typeof toast.description === 'string' ? `: ${toast.description}` : '';
      const severity = toast.status === 'danger' ? 'error' : toast.status;

      alertApi.post({
        message: `${title}${description}`,
        severity: severity === 'neutral' ? 'info' : severity,
        display: toast.timeout === undefined ? 'permanent' : 'transient',
      });

      return { close() {} };
    },
  }),
});

export const apis: AnyApiFactory[] = [
  toastApiFactory,
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
];
